import { render, staticRenderFns } from "./AdminSearchResults.vue?vue&type=template&id=056b3938&"
import script from "./AdminSearchResults.vue?vue&type=script&lang=js&"
export * from "./AdminSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./AdminSearchResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports